import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CORE_ROUTES } from './core.routes';
import { NavigationService } from '../shared/navigation.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RegisterConfirmComponent } from './register/register-confirm/register-confirm.component';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { ActivateLoginComponent } from './activate-login/activate-login.component';
import { CldrIntlService, IntlModule, IntlService } from '@progress/kendo-angular-intl';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { NgxTurnstileFormsModule, NgxTurnstileModule } from 'ngx-turnstile';
import { RecaptchaModule } from 'ng-recaptcha-2';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(CORE_ROUTES),
    SharedModule,
    IntlModule,
    ButtonsModule,
    NgxTurnstileModule,
    NgxTurnstileFormsModule,
    RecaptchaModule
  ],
  declarations: [
    SidebarComponent,
    DashboardComponent,
    LoginComponent,
    RegisterComponent,
    RegisterConfirmComponent,
    TopNavbarComponent,
    RecoveryComponent,
    ResetPasswordComponent,
    PrivacyComponent,
    TermsComponent,
    ActivateLoginComponent
  ],
  exports: [
    TopNavbarComponent,
    SidebarComponent
  ],
  providers: [
    NavigationService,
    { provide: IntlService, useClass: CldrIntlService },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: LOCALE_ID, useValue: 'it-IT' }],
})
export class CoreModule {
}
